import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  SALES_FEATURE_KEY,
  salesAdapter,
  SalesPartialState,
  SalesState,
} from './sales.reducer';

// Lookup the 'Orders' feature state managed by NgRx
export const getSalesState = createFeatureSelector<
  SalesPartialState,
  SalesState
>(SALES_FEATURE_KEY);

const { selectAll, selectEntities } = salesAdapter.getSelectors();

export const getSalesOrdersLoaded = createSelector(
  getSalesState,
  (state: SalesState) => state.loaded
);

export const getSalesOrdersError = createSelector(
  getSalesState,
  (state: SalesState) => state.error
);

export const getSalesAllOrders = createSelector(
  getSalesState,
  (state: SalesState) => selectAll(state)
);

export const getSalesOrdersEntities = createSelector(
  getSalesState,
  (state: SalesState) => selectEntities(state)
);

export const getSalesSelectedId = createSelector(
  getSalesState,
  (state: SalesState) => state.selectedId
);

export const getSalesSelected = createSelector(
  getSalesOrdersEntities,
  getSalesSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getSalesLocations = createSelector(
  getSalesState,
  (state: SalesState) => state.locations
);

export const getSalesAddingOrUpdatingEvent = createSelector(
  getSalesState,
  (state: SalesState) => state.addingOrUpdatingEvent
);

export const getSalesOrderDirection = createSelector(
  getSalesState,
  (state: SalesState) => state.orderDirection
);

export const getSalesLocationType = createSelector(
  getSalesState,
  (state: SalesState) => state.locationType
);

export const getSalesSelectedLocationIds = createSelector(
  getSalesState,
  (state: SalesState) => state.locationIds
);

export const getSalesSelectedCustomerIds = createSelector(
  getSalesState,
  (state: SalesState) => state.customerIds
);
export const getSalesSelectedDateRange = createSelector(
  getSalesState,
  (state: SalesState) => state.dateRange
);

export const getSalesQuery = createSelector(
  getSalesState,
  (state: SalesState) => state.query
);

export const getSalesNextPage = createSelector(
  getSalesState,
  (state: SalesState) => state.nextPage
);

export const saleMessages = createSelector(
  getSalesState,
  (state: SalesState) => state.messages
);

export const getSalesStatus = createSelector(
  getSalesState,
  (state: SalesState) => state.status
);
